import React from 'react';

import { Helmet } from 'react-helmet';

import { Box, Container } from '@mui/material';

import PageHeader from '~/components/Common/Elements/PageHeader';

import CampaignBreadcrumbs from './components/CampaignBreadcrumbs';
import CampaignsList from './components/CampaignsList';

export default function AccommodationCampaignsContainer() {
  return (
    <Container maxWidth="xl">
      <Helmet>
        <title>Campaigns</title>
      </Helmet>
      <CampaignBreadcrumbs />
      <PageHeader title="Campaigns" />

      <Box mt={2}>
        <CampaignsList />
      </Box>
    </Container>
  );
}
